module.exports = __webpack_public_path__ + "img/base.c3b0c277.jpg";